import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Password' })(() => ({
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
}));
